<template>
  <BaseTableView :head="tableHead" list-view="lgAndUp">
    <WorkRegionTableItem v-for="item in items" :key="item.id" :item="item" />
  </BaseTableView>
</template>

<script>
import WorkRegionTableItem from 'components/setting/workRegion/WorkRegionTableItem'
export default {
  name: 'WorkRegionTable',
  props: ['items'],
  components: { WorkRegionTableItem },
  data() {
    return {}
  },
  computed: {
    tableHead() {
      return [
        {
          text: this.localStorage.translations.pages['setting-region']['tables']['nazvanie'],
          sort: {
            name: 'name',
            value:
              this.$route.query.sort_param && this.$route.query.sort_param === 'name'
                ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                  ? 'asc'
                  : 'desc'
                : 'desc',
          },
        },
        {text: '', active: true},
      ]
    },
  },
}
</script>
